<template>
  <div class="login">
      <div class="login-header">
        <h3 style = "color:black">Let's create a new account</h3>
      </div>
      <div class="login-form">
        <h5>Email:</h5>
        <input type="text" v-model="email" placeholder="Email"/><br>
        <!--<h5>Password:</h5>
        <input type="password" v-model="password" placeholder="Password"/>--> <!--Password will be reset after email is verified-->
        <br>
        <!--<input type="button" @click="signUp" value="Sign Up" class="login-button"/>-->
        <button v-on:click="signUp" class="login-button">Sign Up</button>
        <br><br>
        <a href="#" >
          <span><router-link to="/login" class="sign-up" style = "color:white; flex: 2">go back to login.</router-link></span>
        </a>
      </div>
  </div>
</template> 

<script>
  import firebase from 'firebase'

  export default{
    name: 'signUp',
    data: function(){
      return{
        email: '',
        password: ''
      }
    },
    watch: {
        email(newEmail) {
          localStorage.emailForSignIn = newEmail;
        }
    },
    methods: {
      signUp: function(){ 
        /*  THIS CREATE ID and PWD straight away.......
        firebase.auth().createUserWithEmailAndPassword(this.email, this.password).then(
          function(user){
             alert('Your account has been created !')           
          },
          function(err){
            alert('Oops. ' + err.message)
          }
        );  */

        /***THIS WILL SEND EMAIL FOR THE ID VERIFICATON ****/
        var actionCodeSettings = {
            // URL you want to redirect back to. The domain (www.example.com) for this
            // URL must be whitelisted in the Firebase Console.
            //url: 'https://www.example.com/finishSignUp?cartId=1234',
            url:'http://www.wewamart.com',
            // This must be true.
            handleCodeInApp: true,
          };
          firebase.auth().sendSignInLinkToEmail(this.email, actionCodeSettings).then(
            function() {
              // The link was successfully sent. Inform the user.
              // Save the email locally so you don't need to ask the user for it again
              // if they open the link on the same device.
              //window.localStorage.setItem('emailForSignIn', this.email);
              alert('Hi ' + localStorage.getItem('emailForSignIn') + ': PLEASE check your email and verify your it via clicking received link!');
              this.$router.replace('home')
          })
          .catch(function(error) {
              // Some error occurred, you can inspect the code: error.code
              alert('sign in error' + error.code);
          });

      }
    }
  }
</script>

<style scoped>
/*
  .signUp {
      margin-top: 40px;
  }
  input {
      margin: 10px 0;
      width: 20%;
      padding: 15px;
  }
  button {
    margin-top: 10px;
    width: 10%;
    cursor: pointer;
  }
  span {
    display: block;
    margin-top: 20px;
    font-size: 11px;
  }*/

   body {
      background:url('http://cdn.wallpapersafari.com/13/6/Mpsg2b.jpg');
      margin:0px;
      font-family: 'Ubuntu', sans-serif;
      background-size: 100% 110%;
    }
    h1, h2, h3, h4, h5, h6, a {
      margin:0; padding:0;
    }
    .login {
      margin:0 auto;
      max-width:500px;
    }
    .login-header {
      color:#fff;
      text-align:center;
      font-size:300%;
    }
    /* .login-header h1 {
      text-shadow: 0px 5px 15px #000; */
    
    .login-form {
      border:.5px solid #fff;
      background:#4facff;
      border-radius:10px;
      box-shadow:0px 0px 10px #000;
    }
    .login-form h3 {
      text-align:left;
      margin-left:40px;
      color:#fff;
    }
    .login-form {
      box-sizing:border-box;
      padding-top:15px;
      padding-bottom:10%;
      margin:5% auto;
      text-align:center;
    }
    .login input[type="text"],
    .login input[type="password"] {
      max-width:400px;
      width: 80%;
      line-height:3em;
      font-family: 'Ubuntu', sans-serif;
      margin:1em 2em;
      border-radius:5px;
      border:2px solid #f2f2f2;
      outline:none;
      padding-left:10px;
    }
    .login-form input[type="button"] {
      height:30px;
      width:100px;
      background:#fff;
      border:1px solid #f2f2f2;
      border-radius:20px;
      color: slategrey;
      text-transform:uppercase;
      font-family: 'Ubuntu', sans-serif;
      cursor:pointer;
    }
    .sign-up{
      color:#f2f2f2;
      margin-left:-50%;
      cursor:pointer;
      text-decoration:underline;
    }
    .no-access {
      color:#E86850;
      margin:20px 0px 20px -57%;
      text-decoration:underline;
      cursor:pointer;
    }
    .try-again {
      color:#f2f2f2;
      text-decoration:underline;
      cursor:pointer;
    }

    /*Media Querie*/
    @media only screen and (min-width : 150px) and (max-width : 530px){
      .login-form h3 {
        text-align:center;
        margin:0;
      }
      .sign-up, .no-access {
        margin:10px 0;
      }
      .login-button {
        margin-bottom:10px;
      }
    }

</style>



// WEBPACK FOOTER //
// src/components/signup.vue